import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';

export const ModalOverlay = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 50%);
  z-index: 1000;
  justify-content: center;
  align-items: flex-end;

  @media (min-width: ${breakpoints.m}) {
    align-items: center;
  }
`;

export const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
  padding: ${spacing.space32};
  background-color: ${nafColor.signature.white};
  width: 100%;
  border-radius: 0;

  @media (min-width: ${breakpoints.m}) {
    padding: ${spacing.space48};
    min-width: 500px;
    max-width: 800px;
    width: auto;
    margin: ${spacing.space16};
  }

  h2 {
    margin: 0;
  }

  p {
    margin: 0;
  }

  h2 + p {
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${spacing.space16};
  right: ${spacing.space16};
  background: none;
  border: none;
  cursor: pointer;
  padding: ${spacing.space8};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: ${spacing.space12};
  margin-top: ${spacing.space8};
`;
